import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AppContainerOptions,
  AppContainerService,
  AppRightDrawerService,
  RightDrawerContent,
  UserMenuItem,
} from '@mydocma/app-container';
import { AuthService, JwtAuthService } from '@mydocma/auth';
import { ConfigProvider } from '@mydocma/core';
import { Project, ProjectService } from '@mydocma/project';
import { Subject, takeUntil } from 'rxjs';
import { MessageCenterComponent } from 'projects/mydocma/pr/src/lib/common/components/message-center/message-center.component';
import { PrConfig } from 'projects/mydocma/pr/src/lib/configuration/pr.config';
import { SideNavBarButtonsEnum } from 'projects/mydocma/pr/src/lib/services/side-navbar.service';
import package_json from '../../../package.json';

@Component({
  selector: 'app-share-link-main',
  templateUrl: './share-link-main.component.html',
  styleUrls: ['./share-link-main.component.scss'],
})
export class ShareLinkMainComponent implements OnInit, OnDestroy {
  public version: string = package_json.version as string;
  public projectName!: string;
  private jwtAuthService: JwtAuthService;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    public shareLinkOptions: AppContainerOptions,
    private appContainerService: AppContainerService,
    readonly appRightDrawerService: AppRightDrawerService,
    private readonly projectService: ProjectService,
    private readonly authService: AuthService,
  ) {
    this.jwtAuthService = this.authService as any;
  }

  async ngOnInit(): Promise<void> {
    const configProvider = new ConfigProvider<PrConfig>({} as PrConfig);
    const config = await configProvider.loadConfigAsync();
    this.appContainerService.notifyChanges((appContainer: AppContainerOptions) => {
      this.shareLinkOptions = appContainer;
      this.shareLinkOptions.appIcon.name = config.appName;
      this.shareLinkOptions.appIcon.color = config.appIconColor;

      this.shareLinkOptions.header.customerSelection = false;
      this.shareLinkOptions.header.projectSelection = false;
      this.shareLinkOptions.header.userMenuItems.version = this.version;

      this.shareLinkOptions.rightDrawer.contents = [
        new RightDrawerContent({
          id: SideNavBarButtonsEnum.MESSAGES,
          componentType: MessageCenterComponent,
        }),
      ];

      this.shareLinkOptions.sideNavBar.isVisible = false;
      this.shareLinkOptions.sideNavBar.classes = ['pr-side-navbar-on-share-link'];
      this.shareLinkOptions.header.userMenuItems?.items?.forEach((item: UserMenuItem) => {
        if (item.id === 'userSettings') {
          item.hidden = true;
        }
        if (item.id === 'signOut') {
          item.click = () => {
            const fullUrl = window.location.origin + this.router.url;
            this.jwtAuthService.signout(undefined, fullUrl);
          };
        }
      });
    });

    this.projectService.currentProject.pipe(takeUntil(this.destroy$)).subscribe((project: Project) => {
      if (project) {
        this.projectName = project?.name + '  ' + project?.desc;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleMessageCenter(open: boolean): void {
    this.appRightDrawerService.toggleContent(SideNavBarButtonsEnum.MESSAGES, this.shareLinkOptions);
  }
}
